
import React from 'react';
import { useGlobalContext } from '../Contexts/GlobalContext';
import { RiRefreshLine } from 'react-icons/ri';
import { timeDifference } from '../Utlils';

const LastFetched = ({ date, loading = false, setReset }) => {
  const { setSnackbar } = useGlobalContext();
  return (
    <div className="flex items-center justify-end gap-1">
      <RiRefreshLine
        size={16}
        className={`text-primary cursor-pointer ${!!loading && 'animate-spin'}`}
        onClick={() => {
          if (
            new Date()?.getTime() - new Date(date || '')?.getTime() >
            1000 * 60
          ) {
            setReset(true);
          } else {
            console.log("hererr");

            setSnackbar({
              open: true,
              msg: `Data is Fresh,Please wait for 1 minute to fetch new data`,
              severity: 'warning',
            });
          }
        }}
      />
      {loading ? (
        <p className="text-[12px]">Fetching...</p>
      ) : (
        <p className="text-[12px]">
          Last fetched{' '}
          <span className="text-primary font-bold">
            {date ? timeDifference(new Date(date)?.getTime()) : '0'}{' '}
          </span>
          ago
        </p>
      )}
    </div>
  );
};

export default LastFetched;
